const component = require('../component/component');

const editList_table = Object.assign({}, component, {
    subelements: {
        table: false,
        toggleHiddenRows: false,
    },
    hiddenRowsVisible: false,
    showRowsButtonText: '',

    init: function () {
        component.init.call(this);

        if (this.subelements.toggleHiddenRows !== false) {
            this.showRowsButtonText = this.subelements.toggleHiddenRows.innerHTML.trim();
            this.subelements.toggleHiddenRows.addEventListener('click', (e) => { e.preventDefault(); this.toggleRows(); });
        }
    },

    toggleRows: function () {
        // Use querySelectorAll (NodeList has forEach; HTMLCollection from .rows does not)
        this.subelements.table.querySelectorAll('tbody tr').forEach((row) => {
            // zit-hook-show-more-row: JS-only marker added in editList_table.tpl on rows
            // past the visible limit; never carries styling/theme classes (see
            // scripts/behaviors.contract.md "JS hook / selector classes").
            if (row.classList.contains('zit-hook-show-more-row')) {
                if (this.hiddenRowsVisible) {
                    this.hm.helper.hideElement(row);
                } else {
                    this.hm.helper.showElement(row);
                }
            }
        });

        if (this.hiddenRowsVisible) {
            this.subelements.toggleHiddenRows.innerHTML = this.showRowsButtonText;
        } else {
            this.subelements.toggleHiddenRows.innerHTML = this.hm.app.utext('showLess');
        }
        this.hiddenRowsVisible = !this.hiddenRowsVisible;
    }
});

module.exports = editList_table;